"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownWidget = void 0;
var tslib_1 = require("tslib");
// tslint:disable:deprecation
var React = tslib_1.__importStar(require("react"));
var DropdownWidget_1 = require("./DropdownWidget");
var MenuItemInfo_1 = require("./MenuItemInfo");
/** @deprecated use `SingleSelectDropdown` */
exports.DropdownWidget = function (props) {
    var convertedProps = tslib_1.__assign(tslib_1.__assign({}, props), { menuItemInfos: MenuItemInfo_1.convertMenuItemInfoToGeneric(props.menuItemInfos, props.selectedValue) });
    return React.createElement(DropdownWidget_1.GenericDropdownWidget, convertedProps);
};
//# sourceMappingURL=DropdownTextWidget.js.map